"use client";

import { TopShopEducationTooltip } from "@faire/retailer-visitor-shared/components/TopShop/TopShopTooltip";
import { TrophyIcon } from "@faire/web--source/slate/icons/Trophy";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";

export const TopShopIcon = ({ iconSize }: { iconSize: string }) => {
  const { isDesktopAndAbove } = useViewport();
  const baseIcon = <TrophyIcon active fontSize={iconSize} titleAccess="" />;
  return isDesktopAndAbove ? (
    <TopShopEducationTooltip icon={baseIcon} />
  ) : (
    baseIcon
  );
};
